import { Model } from '@vuex-orm/core'

export default class Notification extends Model {
  static entity = 'notifications'

  static fields() {
    return {
      id: this.string(),
      notifiable_id: this.string(''),
      notifiable_type: this.string(''),
      type: this.string(''),
      data: this.attr(),
      created_at: this.string(''),
      updated_at: this.string(''),
      read_at: this.attr(null)
    }
  }
}
